import { Sector } from '@/domain/impact/impact.entity';
import {
  Category,
  ImpactCo2Answer,
  ValuesTeamMobility,
} from '@/domain/impact-co2/entities/question.entity';

import { ImportedRow } from '../convert-excel-to-impact-answers';
import { buildBaseAnswer } from './common/build-base-answer';
import {
  filterRowsByCategory,
  filterRowsBySectors,
} from './common/filter-rows-by-category';
import {
  mapToPassengerCount,
  mapToTransportationMode,
  mapToTravelDistance,
} from './mobility';

// TGS do not specify TEAM_MOBILITY category
// in this mapper we convert MOBILITY category with TEAM sector to TEAM_MOBILITY answers

const CATEGORY: Category = 'MOBILITY';
const SECTORS: Sector[] = ['TEAM'];
const CATEGORY_MAPPED: Category = 'TEAM_MOBILITY';

export function mapToTeamMobilityAnswers(
  rows: ImportedRow[],
): ImpactCo2Answer<ValuesTeamMobility>[] {
  return rows
    .filter(filterRowsByCategory(CATEGORY))
    .filter(filterRowsBySectors(SECTORS))
    .map((row) => buildAnswer(row));
}

function buildAnswer(row: ImportedRow) {
  const transportationMode = mapToTransportationMode(row);
  const passengerCount = mapToPassengerCount(row);
  const travelDistance = mapToTravelDistance(row);
  const numberOfDays = 1;
  const baseAnswer = buildBaseAnswer(row, CATEGORY_MAPPED);
  const answer = {
    ...baseAnswer,
    values: {
      ...baseAnswer.values,
      transportationMode,
      passengerCount,
      travelDistance,
      numberOfDays,
    },
  };
  return answer;
}
